// extracted by mini-css-extract-plugin
module.exports = {"circular":"preloader_circular__VUJIS","rotate":"preloader_rotate__oNd2n","path":"preloader_path__nsfoq","dash":"preloader_dash__Ae3Es"};